// extracted by mini-css-extract-plugin
export const icon = "info-message-module--icon--1K1Xx";
export const floatIcon = "info-message-module--float-icon--ME0Gm";